import _Check from "@mui/icons-material/Check";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import madScientist from '../../../assets/images/bttf/mad-scientist.svg';
import { useUnits } from '../../../hooks';
import { DurationIcon } from '../../icons';
function Progression({
  event
}) {
  const [initialized, setInitialized] = useState(false);
  const {
    targetLevels,
    sumOfProgressValues
  } = event;
  const {
    t
  } = useTranslation();
  useEffect(() => {
    if (initialized && typeof window !== 'undefined') {
      const el = document.querySelector('#active-thumb');
      if (el) {
        const observer = new window.IntersectionObserver(([entry]) => {
          if (entry.isIntersecting) {
            el.classList.add('visible');
            document.getElementById('active-mark')?.classList.add('visible');
            return;
          }
          el.classList.remove('visible');
          document.getElementById('active-mark')?.classList.remove('visible');
        }, {
          root: null,
          threshold: 0.1
        });
        observer.observe(el);
      }
    } else {
      setInitialized(true);
    }
  }, [initialized]);
  if (!targetLevels || targetLevels.length === 0) return /*#__PURE__*/React.createElement(React.Fragment, null);
  const currentLevel = targetLevels.findIndex(({
    targetValue
  }, index) => sumOfProgressValues < targetValue || index === targetLevels.length - 1);
  const prevLevel = currentLevel > 0 ? currentLevel - 1 : undefined;
  const nextLevel = currentLevel < targetLevels.length - 1 ? currentLevel + 1 : undefined;
  const nextNextLevel = currentLevel < targetLevels.length - 2 ? currentLevel + 2 : undefined;
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#6210FF",
    borderRadius: 4,
    color: "#fff",
    display: "flex",
    flexDirection: "column",
    gap: 2,
    padding: 3
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 3,
    justifyContent: "space-between"
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "inherit",
    fontWeight: 700
  }, t('commons.challenges.global_progression_card.title')), event.challengeTemplate && /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 1
  }, /*#__PURE__*/React.createElement(DurationIcon, {
    sx: {
      height: 14,
      width: 14
    }
  }), /*#__PURE__*/React.createElement(_Typography, {
    color: "inherit",
    lineHeight: 1,
    variant: "body2"
  }, event.challengeTemplate.period === 'past' ? t('commons.done') : event.challengeTemplate.daysToWait > 0 ? t('commons.challenges.days_to_wait', {
    count: event.challengeTemplate.daysToWait
  }) : t('commons.challenges.days_left', {
    count: event.challengeTemplate.daysLeft
  })))), /*#__PURE__*/React.createElement(_Box, {
    overflow: "hidden"
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "stretch",
    display: "flex",
    gap: 2,
    marginLeft: currentLevel === 0 ? 0 : `calc(((-100% + 80px) * ${currentLevel}) + 24px)`,
    sx: {
      containerType: 'inline-size'
    },
    width: "100%"
  }, targetLevels.map((level, index) => /*#__PURE__*/React.createElement(Card, {
    active: index === currentLevel,
    key: index,
    level: {
      index,
      ...level
    },
    levelsCount: targetLevels.length
  })))), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 0.5
  }, /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    height: 44,
    position: "relative"
  }, /*#__PURE__*/React.createElement(_Box, {
    borderRadius: 1,
    height: 8,
    position: "relative",
    sx: {
      background: 'linear-gradient(90deg, #D9E7FF 21.15%, #8F54FF 100%)'
    },
    width: "100%",
    zIndex: 1
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#00bcac",
    borderRadius: 1,
    bottom: 0,
    left: 0,
    position: "absolute",
    top: 0,
    width: prevLevel === undefined ? 50 : '50%'
  })), prevLevel === undefined ? /*#__PURE__*/React.createElement(Thumb, {
    bgcolor: "#dbc9ff",
    left: "calc(50% - 50px)",
    level: currentLevel + 1
  }) : /*#__PURE__*/React.createElement(Thumb, {
    passed: true,
    bgcolor: "#d9e7ff",
    left: 0,
    level: currentLevel
  }), prevLevel === undefined ? nextNextLevel && /*#__PURE__*/React.createElement(Thumb, {
    bgcolor: "#a87bff",
    level: nextNextLevel,
    right: 0
  }) : nextLevel && /*#__PURE__*/React.createElement(Thumb, {
    bgcolor: "#a87bff",
    level: nextLevel,
    right: 0
  }), /*#__PURE__*/React.createElement(ActiveThumb, {
    left: "calc(50px - 22px)",
    sx: {
      '&.visible': {
        left: prevLevel === undefined ? 'calc(50px - 22px)' : 'calc(50% - 22px)'
      }
    }
  })), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    display: "flex",
    gap: 2,
    justifyContent: "space-between"
  }, prevLevel !== undefined && /*#__PURE__*/React.createElement(Mark, {
    targetValue: targetLevels[prevLevel].targetValue
  }), /*#__PURE__*/React.createElement(ActiveMark, {
    sumOfProgressValues: sumOfProgressValues
  }), nextLevel ? /*#__PURE__*/React.createElement(Mark, {
    targetValue: targetLevels[currentLevel].targetValue
  }) : /*#__PURE__*/React.createElement(_Box, {
    width: 100
  }), prevLevel === undefined && nextLevel && nextNextLevel && /*#__PURE__*/React.createElement(Mark, {
    targetValue: targetLevels[nextLevel].targetValue
  }))));
}
function ActiveThumb({
  ...props
}) {
  return /*#__PURE__*/React.createElement(_Box, _extends({
    alignItems: "center",
    display: "flex",
    height: 44,
    id: "active-thumb",
    justifyContent: "center",
    left: 0,
    position: "absolute",
    top: 0,
    width: 44,
    zIndex: 2
  }, props, {
    sx: {
      transition: 'left 1s ease-in',
      ...props.sx
    }
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: "#330096",
    borderRadius: 6,
    display: "flex",
    height: 44,
    justifyContent: "center",
    width: 44
  }, /*#__PURE__*/React.createElement("img", {
    height: 44,
    src: madScientist,
    width: 44
  })));
}
function Thumb({
  bgcolor,
  level,
  passed,
  ...props
}) {
  return /*#__PURE__*/React.createElement(_Box, _extends({
    alignItems: "center",
    display: "flex",
    height: 44,
    justifyContent: "center",
    position: "absolute",
    top: 0,
    width: 100,
    zIndex: 2
  }, props), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "center",
    bgcolor: passed ? '#2fecc3' : bgcolor,
    borderRadius: 4,
    display: "flex",
    height: 32,
    justifyContent: "center",
    width: 32
  }, passed ? /*#__PURE__*/React.createElement(_Check, {
    sx: {
      color: '#fff'
    }
  }) : /*#__PURE__*/React.createElement(_Typography, {
    color: "#6210ff",
    fontWeight: 700
  }, level + 1)));
}
function ActiveMark({
  sumOfProgressValues
}) {
  const {
    formatNumber
  } = useUnits();
  return /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#330096",
    borderRadius: 4,
    id: "active-mark",
    paddingX: 1,
    paddingY: 0.5,
    sx: {
      opacity: 0,
      transition: 'opacity 0s ease-in',
      '&.visible': {
        opacity: 1,
        transition: 'opacity 0.5s 1s linear'
      }
    },
    width: 100
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "center",
    color: "#fff",
    fontWeight: 700,
    variant: "body2"
  }, formatNumber(sumOfProgressValues), "\xA0pts"));
}
function Mark({
  targetValue
}) {
  const {
    formatNumber
  } = useUnits();
  return /*#__PURE__*/React.createElement(_Box, {
    width: 100
  }, /*#__PURE__*/React.createElement(_Typography, {
    noWrap: true,
    align: "center",
    color: "rgba(255, 255, 255, 0.6)",
    fontWeight: 700,
    variant: "body2"
  }, formatNumber(targetValue), "\xA0pts"));
}
function Card({
  levelsCount,
  level: {
    index,
    picture,
    title,
    description
  },
  active
}) {
  const {
    t
  } = useTranslation();
  return /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    bgcolor: "#fff",
    borderRadius: 2,
    display: "flex",
    flexDirection: {
      '@': 'column',
      '@500': 'row'
    },
    flexShrink: 0,
    gap: 2,
    padding: 2,
    sx: !active ? {
      opacity: 0.4
    } : {},
    width: "calc(100% - 16px - 80px)"
  }, /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: {
      '@': '100%',
      '@500': 172
    }
  }, /*#__PURE__*/React.createElement("img", {
    src: picture,
    style: {
      borderRadius: 8,
      filter: active ? undefined : 'blur(0.25rem)'
    },
    width: "100%"
  })), /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column",
    gap: 1,
    sx: active ? {} : {
      filter: 'blur(0.25rem)'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    display: "flex",
    flexDirection: "column"
  }, /*#__PURE__*/React.createElement(_Typography, {
    color: "#6210ff",
    fontWeight: 700,
    variant: "body2"
  }, t('commons.challenges.global_progression_card.level', {
    level: index + 1,
    count: levelsCount
  })), /*#__PURE__*/React.createElement(_Typography, {
    color: "#6210ff",
    fontSize: "1.15rem",
    fontWeight: 700
  }, title)), /*#__PURE__*/React.createElement(_Typography, {
    color: "#2c2e30",
    variant: "body2"
  }, description)));
}
export default Progression;